import styled from 'styled-components';
export default styled.div `
  ${({ shouldFitContainer }) => shouldFitContainer ? '' : 'max-width: 300px;'};
`;
//# sourceMappingURL=WidthConstrainer.js.map